import Events from 'events/events'
import debounce from 'debounce'

import quantityButtonsTemplate from 'coreComponents/buttons/quantity-buttons/quantity-buttons.hbs';

export const quantityFieldUpdatedEvent = 'quantityFieldUpdated';
const QUANTITY_PUBLISH_WAIT_MILLIS = 1000;

function createQuantityUpdatedEvent(value) {
  Events.quantityUpdated.trigger(value);

  return new CustomEvent(quantityFieldUpdatedEvent, {
    bubbles: true,
    detail: {
      quantity: value
    }
  });
}

var QuantityField = function(quantityElement) {

  var _this = this;
  setup();

  function setup() {
    _this.quantityElement = quantityElement;
    _this.quantityInput = _this.quantityElement.querySelector('input.quantity-input');
    _this.quantityWrapper = _this.quantityElement.querySelector('.quantity-wrapper');
    _this.disableButtons = _this.quantityInput.getAttribute("data-disable-buttons") === "true"
    _this.recentValue = getValue();

    _this.quantityElement.classList.add('js-enabled');
    if (_this.quantityWrapper){
      _this.quantityWrapper.classList.add('js-enabled');
    }

    var basketListItemContainer = quantityElement.closest(".basket-list-item");
    var errorMessageId = "productQuantityError";
    if (basketListItemContainer) {
      errorMessageId = "error_"+basketListItemContainer.id;
    }

    attachButtons(errorMessageId);

    if (_this.quantityInput.getAttribute('disabled') != 'disabled') {
      addEventListeners();
      updateButtonStates(true);
    }
  }

  function addEventListeners() {
    if(!_this.disableButtons) {
      _this.quantityPlusButton.el.addEventListener('click', function() {
        increment();
      });
      _this.quantityMinusButton.el.addEventListener('click', function() {
        decrement();
      });
    }

    for (let eventName of ['keyup', 'cut', 'paste']) {
      _this.quantityInput.addEventListener(eventName, function() {
        updateButtonStates();
      });
    }
    if (_this.quantityInput.closest('.view-basket-main') && _this.quantityInput.closest('.view-basket-list--updated')) {
      _this.quantityInput.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '').replace(/^00/g, '0');
      });
    }
  }

  function attachButtons(lineItemErrorMessageId) {
    if(_this.disableButtons) {
      return;
    }

    var buttonsHtml = quantityButtonsTemplate({
      'disabled':true,
      'lineItemErrorMessageId':lineItemErrorMessageId
    });

    var div = document.createElement('div');
    div.innerHTML = buttonsHtml;

    var increaseButton = div.querySelector('.quantity-increase-button');
    var decreaseButton = div.querySelector('.quantity-decrease-button');

    _this.quantityInput.parentNode.insertBefore(decreaseButton, _this.quantityInput);
    _this.quantityInput.parentNode.insertBefore(increaseButton, _this.quantityInput.nextSibling);

    _this.quantityMinusButton = new Button(decreaseButton);
    _this.quantityPlusButton = new Button(increaseButton);
  }

  function increment() {
    var value = getValueAsNumber();
    if (isNaN(value)) {
      setValue(1);
    } else {
      setValue(value + 1);
    }
    updateButtonStates();
  }

  function decrement() {
    var value = getValueAsNumber();
    if (isNaN(value)) {
      setValue(1);
    } else {
      setValue(value - 1);
    }
    updateButtonStates();
  }

  function getMaxValue() {
    var maxValue = parseInt(_this.quantityInput.getAttribute('data-max-number'));
    if (isNaN(maxValue)) {
      maxValue = 999;
    }
    return maxValue;
  }

  function updateButtonStates(initialSetup = false) {
    if (!initialSetup) {
      publishQuantityIfModified();
    }

    if (_this.disableButtons) {
      return;
    }

    if (_this.quantityInput.value === '') {
      _this.quantityMinusButton.disable();
      _this.quantityPlusButton.enable();
    } else if (isNaN(getValueAsNumber()) || !isInteger()) {
      _this.quantityMinusButton.disable();
      _this.quantityPlusButton.disable();
    } else {
      if (getValueAsNumber() >= getMaxValue()) {
        _this.quantityPlusButton.disable();
      } else {
        _this.quantityPlusButton.enable();
      }

      if (getValueAsNumber() <= 1 && !isBasketProductQuantityEl(_this.quantityMinusButton.el)) {
        _this.quantityMinusButton.disable();
      } else if (getValueAsNumber() <= 0 && isBasketProductQuantityEl(_this.quantityMinusButton.el)) {
        _this.quantityMinusButton.disable();
      } else {
        _this.quantityMinusButton.enable();
      }
    }
  }

  let publishQuantityIfModified = debounce(() => {
    if (getValue() != _this.recentValue) {
      _this.quantityInput.dispatchEvent(createQuantityUpdatedEvent(getValue()));
      _this.recentValue = getValue();
    }
  }, QUANTITY_PUBLISH_WAIT_MILLIS);

  function isInteger() {
    var value = _this.quantityInput.value;
    return (value == parseInt(value, 10));
  }

  function getValue() {
    return _this.quantityInput.value;
  }

  function getValueAsNumber() {
    return parseInt(getValue(), 10);
  }

  function setValue(newValue) {
    _this.quantityInput.value = newValue;
  }

  function isBasketProductQuantityEl(quantityEl) {
    return !!(quantityEl.closest(".product-quantity--basket") || quantityEl.closest(".product-quantity--basket-invalid")) && !!quantityEl.closest(".view-basket-list--updated");
  }
};

function init(containingClass) {
  var containers = document.querySelectorAll('.' + containingClass + ':not(.js-enabled)');
  for (let container of containers) {
    if (container.querySelector('input.quantity-input')) {
      new QuantityField(container);
    }
  }
}

function listenForChanges(containingClass) {
  Events.quantityFieldsReplaced.register(function() {
    init(containingClass);
  });
}

function Button(buttonElement) {
  this.el = buttonElement;
  this.buttonClass = buttonElement.classList[0];
  this.icon = buttonElement.querySelector('path');
  this.iconClass = this.icon.classList[0];

  this.disable = () => {
    this.el.classList.add(this.buttonClass + "--disabled");
    this.icon.classList.add(this.iconClass + "--disabled");
    this.el.setAttribute("disabled", "disabled");
  }
  this.enable = () => {
    this.el.classList.remove(this.buttonClass + "--disabled");
    this.icon.classList.remove(this.iconClass + "--disabled");
    this.el.removeAttribute("disabled");
  }
}

export default {
  init : function(containingClass) {
    init(containingClass);
    listenForChanges(containingClass);
  }
}
